module.exports = __webpack_public_path__ + "static/banner-sports-8bafd4100f8c3a24e87b173af7b6ccee.jpg";